import React, { useState } from "react";
import { ClipboardCopy } from "./../../Public/assets/index";
import { Eye, EyeOff } from "lucide-react";

const AccountDetailsForm = ({ data }) => {
  const [showFull, setShowFull] = useState(false);
  const [copiedKey, setCopiedKey] = useState(null);

  const displayNumber = showFull
    ? data?.vendorAccountNo
    : `*******${data?.vendorAccountNo?.slice(-4) || ""}`;

  const accountDetails = [
    {
      label: "Account Holder Name",
      value:
        [data?.user?.firstName, data?.user?.middleName, data?.user?.lastName]
          .filter(Boolean)
          .join(" ") || "...",
      key: "A",
    },
    { label: "Bank Name", value: data?.vendorBankName || "...", key: "B" },
    {
      label: "Bank Account Number",
      value: data?.vendorAccountNo ? displayNumber : "...",
      key: "C",
      hasToggle: true,
    },
    { label: "Bank Code", value: data?.bankCode || "...", key: "D" },
    { label: "Branch Code", value: data?.branchCode || "...", key: "E" },
    { label: "SWIFT Code", value: data?.vendorSwiftCode || "...", key: "F" },
    // { label: "Account Type", value: data?.accountType || "..." },
    // { label: "Account Location", value: data?.vendorCity || "..." },
    {
      label: "Bank Address",
      value:
        data?.vendorAddress && data?.vendorState && data?.vendorCountry
          ? data?.vendorAddress +
            ", " +
            data?.vendorState +
            ", " +
            data?.vendorCountry
          : "...",
      key: "G",
    },
    { label: "Country", value: data?.vendorCountry || "...", key: "H" },
  ];

  // Copy handler function
  const handleCopyAll = () => {
    const fullAccountNumber = data?.vendorAccountNo || "";
    const textToCopy = accountDetails
      .map((detail) => {
        if (detail.label === "Bank Account Number") {
          return `${detail.label}: ${fullAccountNumber}`;
        }
        return `${detail.label}: ${detail.value}`;
      })
      .join("\n");

    navigator.clipboard.writeText(textToCopy);
    setCopiedKey("All");
    setTimeout(() => setCopiedKey(null), 2000);
  };

  const handleCopy = (value, key) => {
    if (value) {
      navigator.clipboard.writeText(value);
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 2000);
    }
  };

  return (
    <div
      className={`bg-white py-[26px] rounded-lg  lg:shadow-minShadow  w-full h-full   font-geomanist text-sm leading-tight`}
    >
      <div className="flex px-6 justify-between items-center mb-6">
        <h2 className="text-xl font-geomanistBold text-blackShade">
          Account Details
        </h2>
        <button
          onClick={handleCopyAll}
          className={`text-blueish hover:text-blue-800 ${
            copiedKey === "All" ? "" : " underline underline-offset-4"
          } `}
        >
          {copiedKey === "All" ? "" : "Copy All"}
          {copiedKey === "All" && (
            <span className="text-sm text-green-500 animate-pulse">
              Copied!
            </span>
          )}
        </button>
      </div>
      <div className="space-y-6 md:!space-y-[42px] px-6">
        {accountDetails.map((detail, index) => (
          <div key={index} className="flex justify-between items-center">
            <span className={` text-greyish font-geomanistRegular`}>
              {detail.label}
            </span>
            <div className="flex items-center justify-end w-2/3">
              <span
                // md:w-auto
                className={`text-blackShade text-right mr-2 w-[80%] md:w-[90%]  ${
                  !detail.value ? "" : ""
                }`}
              >
                {detail.value}
              </span>
              {detail.hasToggle && (
                <button
                  onClick={() => setShowFull(!showFull)}
                  className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                  aria-label={
                    showFull
                      ? "Hide account number"
                      : "Show full account number"
                  }
                >
                  {showFull ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              )}

              <button
                // md:w-auto
                className={`flex justify-end ${
                  copiedKey === detail.key ? "" : "w-[10%] md:w-[6%] "
                }  gap-[7px]`}
                onClick={() =>
                  handleCopy(
                    detail?.hasToggle ? data?.vendorAccountNo : detail?.value,
                    detail?.key
                  )
                }
              >
                <img
                  src={ClipboardCopy}
                  alt="clipboard"
                  className={` ${copiedKey === detail.key ? "hidden" : ""}`}
                />
                {copiedKey === detail.key && (
                  <span className="text-sm text-green-500 animate-pulse">
                    Copied!
                  </span>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AccountDetailsForm;
